export class RouletteBetType {
    //******************************************************************************************************************
    //  Bets
    //******************************************************************************************************************

    public static Single: string = "Single";
    public static SplitVertical: string = "SplitVertical";
    public static SplitHorizontal: string = "SplitHorizontal";
    public static Street: string = "Street";
    public static Corner: string = "Corner";
    public static DoubleStreet: string = "DoubleStreet";
    public static Trio: string = "Trio";
    public static FirstFour: string = "FirstFour";
    public static Basket: string = "Basket";
    public static LowOrHigh: string = "LowOrHigh";
    public static RedOrBlack: string = "RedOrBlack";
    public static EvenOrOdd: string = "EvenOrOdd";
    public static Dozen: string = "Dozen";
    public static Column: string = "Column";

    public static LowNumbers: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
    public static HighNumbers: Array<number> = [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36];
    public static RedNumbers: Array<number> = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
    public static BlackNumbers: Array<number> = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];
    public static EvenNumbers: Array<number> = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36];
    public static OddNumbers: Array<number> = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35];
    public static DozenNumbers: Array<Array<number>> = [
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
        [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
    ];
    public static ColumnNumbers: Array<Array<number>> = [
        [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
        [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
        [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
    ];
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/RouletteBetType.ts
 **/